enum IntegrationStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PRIVATE = "private",
  DEPRECATED = "deprecated",
}


export { IntegrationStatus };